function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L45 0L45 45L0 45L0 0Z",
  id: "symphony_path_1"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "symphony_mask_1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#symphony_path_1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "header-logo-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L45 0L45 45L0 45L0 0Z",
  id: "header-logo-1-(Background/Mask)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#symphony_mask_1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.4688 44.2568C10.0596 44.2568 0 34.3496 0 22.1284C0 9.90723 10.0596 0 22.4688 0C34.878 0 44.9377 9.90723 44.9377 22.1284C44.9377 34.3496 34.878 44.2568 22.4688 44.2568Z",
  transform: "translate(0 0.14355469)",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.0829 3.03511C17.4408 4.9142 16.3483 7.14307 15.5612 9.41829C14.153 8.2817 13.0668 6.81034 10.8078 6.16875C9.06178 5.67511 7.22786 5.87897 5.5414 7.11647C4.74248 7.7042 4.19209 8.59261 3.9304 9.42784C3.25263 11.5981 4.64278 13.5297 5.27417 14.2231L6.65463 15.6801C6.93917 15.9658 7.62455 16.711 7.28948 17.7794C6.9274 18.9412 5.5054 19.6933 4.04671 19.2501C3.39525 19.0544 2.45925 18.5765 2.66901 17.9035C2.75555 17.6281 2.95563 17.4222 3.06294 17.1842C3.16125 16.9797 3.20832 16.8262 3.23809 16.7362C3.50463 15.8792 3.14048 14.7644 2.20863 14.4815C1.33909 14.219 0.449476 14.4269 0.104707 15.5294C-0.286447 16.7819 0.322092 19.0551 3.58217 20.0451C7.40163 21.2008 10.6326 19.1526 11.0909 16.4812C11.3796 14.8081 10.6126 13.5651 9.20717 11.9662L8.06209 10.7192C7.3684 10.0367 7.13025 8.87352 7.84817 7.97966C8.45394 7.22557 9.31655 6.90375 10.7296 7.28216C12.7919 7.83375 13.7113 9.24307 15.2455 10.3797C14.612 12.4258 14.198 14.4794 13.8235 16.321L13.595 17.6942C12.4984 23.3587 11.6614 26.4692 9.48617 28.2549C9.04794 28.5617 8.4214 29.0212 7.47709 29.0533C6.98209 29.0683 6.82217 28.7328 6.81525 28.5869C6.80348 28.2447 7.09632 28.0878 7.29086 27.9337C7.58163 27.7776 8.02125 27.5185 7.99148 26.6887C7.95963 25.7083 7.13509 24.8581 5.94294 24.8969C5.04986 24.9269 3.68878 25.7547 3.74002 27.2697C3.79332 28.8344 5.27417 30.0072 7.50686 29.9328C8.7004 29.8926 11.3658 29.414 13.9924 26.339C17.0496 22.814 17.9046 18.7728 18.5478 15.8151L19.2657 11.9103C19.6645 11.9574 20.0909 11.9887 20.5548 11.9997C24.3625 12.0787 26.267 10.1362 26.2954 8.72352C26.3141 7.86852 25.7256 7.02716 24.9018 7.04625C24.3119 7.06261 23.5712 7.4492 23.3932 8.25238C23.2195 9.04057 24.6048 9.7517 23.522 10.4424C22.7529 10.9326 21.3738 11.2783 19.4319 10.9974L19.7849 9.07534C20.5056 5.43034 21.3946 0.946702 24.7668 0.837611C25.0126 0.825338 25.9119 0.84852 25.9326 1.4342C25.9389 1.62988 25.8897 1.67966 25.6571 2.12761C25.4203 2.4767 25.331 2.77398 25.3421 3.11557C25.3746 4.04625 26.0932 4.65784 27.1324 4.62102C28.5239 4.5767 28.9241 3.24238 28.9012 2.55716C28.8452 0.947384 27.122 -0.0698891 24.8409 0.00374723L24.8409 0.00374723C22.5583 0.0821563 20.5659 1.32102 19.0829 3.03511Z",
  transform: "translate(7.451172 8.327148)",
  id: "Vector",
  fill: "#040624",
  fillRule: "evenodd",
  stroke: "none"
})));

var SvgSymfony = function SvgSymfony(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSymfony, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/symfony.c1b6cb60.svg";
export { ForwardRef as ReactComponent };